import { apiAddress } from "../../config/server";
import { IAssociation } from "../../types/association/Association";
import { ICompetition } from "../../types/competition/Competition";
import { ApiBase } from "./baseApi";

export default class CompetitionApi extends ApiBase {
  static CompetitionApiAddress = `${apiAddress}/api/competition/`;

  static GetAllCompetitions = CompetitionApi.CompetitionApiAddress;

  static getAllCompetitions(): Promise<ICompetition[]> {
    return CompetitionApi.get<ICompetition[]>(this.GetAllCompetitions).then(
      (response) => response.data.data,
    );
  }

  static getCompetitionById(
    competitionId: string,
  ): Promise<{ competition: ICompetition; association?: IAssociation }> {
    return CompetitionApi.get<ICompetition>(
      this.CompetitionApiAddress + competitionId,
    ).then((response) => ({
      competition: response.data.data,
      association: response.data.associations?.[0],
    }));
  }

  static updateCompetition(
    competition: Partial<ICompetition>,
  ): Promise<ICompetition> {
    return CompetitionApi.patch<ICompetition>(
      this.CompetitionApiAddress + competition._id,
      competition,
    ).then((response) => response.data.data);
  }

  static addCompetitionTag(
    competitionId: string,
    tag: string,
  ): Promise<ICompetition> {
    return CompetitionApi.put<ICompetition>(
      `${this.CompetitionApiAddress}${competitionId}/tag/${tag}`,
    ).then((response) => response.data.data);
  }

  static removeCompetitionTag(
    competitionId: string,
    tag: string,
  ): Promise<ICompetition> {
    return CompetitionApi.delete<ICompetition>(
      `${this.CompetitionApiAddress}${competitionId}/tag/${tag}`,
    ).then((response) => response.data.data);
  }
}
